import {
  Box,
  Button,
  CircularProgress,
  Divider,
  Grid,
  Stack,
  TextField,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { RightPanel } from "../../../components/RightPanel";
import { useDispatchWrapper } from "../../../hooks";
import { IStoreState } from "../../../redux/initialStoreState";
import { useSelector } from "react-redux";
import { LoadState } from "../../../constants/enums";
import { ExcelFileUplaodButtonAsync } from "../components/ExcelFileUplaodButtonAsync";
import { saveMarketCampaignAudienceListAsync } from "../../../redux/marketCampaign/marketCampaignActions";
import { useBillingCompanyContext } from "../../../providers";
import DescriptionIcon from "@mui/icons-material/Description";
import { SingleFileDisplay } from "../../../components/FileUpload/components/SingleFileDisplay";
import MappedAudience from "./MappedAudience";

interface ICreateAudienceRightPanelProps {
  open: boolean;
  data?: any;
  onClose: () => void;
  onSuccess?: () => void;
  heading?: string;
  type?: string;
  fileUploadSuccess?: (path: string) => void;
}

export const CreateAudienceRightPanel: React.FC<
  ICreateAudienceRightPanelProps
> = ({ open, data, onClose, onSuccess, heading, type, fileUploadSuccess }) => {
  const dispatch = useDispatchWrapper();
  const { loading } = useSelector(
    (storeState: IStoreState) =>
      storeState.marketCampaign.marketCampaignAudience,
  );
  const companyOutlet = useBillingCompanyContext();

  const [formData, setFormData] = useState({
    audience_name: data?.audience_name || "",
    source_link: data?.source_link || [],
  });

  const [error, setError] = useState("");
  const [openMappedAudience, setOpenMappedAudience] = React.useState(false);
  const [uploadedHeaders, setUploadedHeaders] = useState<string[]>([]);
  const [mappingKeys, setMappingKeys] = useState<any[]>([]);
  const [isMappingCompleted, setIsMappingCompleted] = useState(false);

  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleAudienceFileUploadSuccess = (
    path: string,
    extractedHeaders?: string[],
  ) => {
    setFormData((prev) => ({
      ...prev,
      source_link: [path],
    }));
    setError("");

    // Reset mapping when new file is uploaded
    setMappingKeys([]);
    setIsMappingCompleted(false);

    // Use extracted headers from the uploaded file
    if (extractedHeaders && extractedHeaders.length > 0) {
      setUploadedHeaders(extractedHeaders);
    } else {
      // Fallback to empty array if no headers extracted
      setUploadedHeaders([]);
    }

    // Open the MappedAudience dialog
    setOpenMappedAudience(true);
  };

  const handleMappingComplete = (mapping_keys?: any[]) => {
    if (mapping_keys) {
      setMappingKeys(mapping_keys);
      setIsMappingCompleted(true);
    }
    setOpenMappedAudience(false);
    // Don't call API here - just save the mapping keys
  };

  const handleSaveMarketCampaignAudienceList = async () => {
    if (!formData.audience_name) {
      setError("Audience name is required");
      return;
    }

    if (formData.source_link.length === 0) {
      setError("Please upload a file");
      return;
    }

    if (!isMappingCompleted || mappingKeys.length === 0) {
      setError("Please complete the field mapping before saving");
      return;
    }

    try {
      const payload = {
        audience_name: formData.audience_name,
        source_link: formData.source_link,
        audience_list: [],
        company_outlet_uuid: companyOutlet.comapny.company_outlet_uuid,
        status: "ACTIVE",
        market_campaign_audience_list_uuid: null,
        mapping_keys: mappingKeys,
      };

      await dispatch(saveMarketCampaignAudienceListAsync(payload));
      onSuccess?.();
      onClose();
    } catch (error) {
      console.error("Error saving audience:", error);
    }
  };
  return (
    <>
      <RightPanel
        heading={heading || ""}
        open={open}
        width="50%"
        onClose={onClose}
        actionButtons={() => {
          return (
            <Stack direction={"row"} justifyContent={"flex-end"} spacing={2}>
              <Button variant="outlined" onClick={onClose}>
                Cancel
              </Button>
              {formData.source_link.length > 0 && (
                <Button
                  variant="contained"
                  onClick={() => setOpenMappedAudience(true)}
                >
                  Re-Map Headers
                </Button>
              )}
              <Button
                variant="contained"
                onClick={handleSaveMarketCampaignAudienceList}
                disabled={
                  loading === LoadState.InProgress ||
                  !isMappingCompleted ||
                  mappingKeys.length === 0
                }
              >
                {loading === LoadState.InProgress ? (
                  <CircularProgress size={24} />
                ) : (
                  "Save"
                )}
              </Button>
            </Stack>
          );
        }}
      >
        <Grid container spacing={3}>
          {type === "AUDIENCE" && (
            <>
              <Grid item xs={12}>
                <Typography variant="h3" fontWeight={600} mb={2}>
                  Audience Details
                </Typography>
                <Divider />
              </Grid>

              <Grid item xs={12}>
                <TextField
                  fullWidth
                  label="Audience Name"
                  name="audience_name"
                  value={formData.audience_name}
                  onChange={handleInputChange}
                  required
                  error={!!error && !formData.audience_name}
                  helperText={!formData.audience_name ? error : ""}
                />
              </Grid>
            </>
          )}

          {/* <Grid item xs={12}>
          <Box sx={{ display: "flex", gap: 2 }}>
            <Typography
              sx={{
                width: "30px",
                height: "30px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                borderRadius: "50%",
                backgroundColor: "primary.main",
                color: "white",
                fontWeight: "bold",
              }}
            >
              1
            </Typography>

            <Box>
              <Typography variant="h3" fontWeight={600}>
                Download Sample File
              </Typography>
              <Typography variant="body1" sx={{ mt: 2 }}>
                Download the sample CSV/Excel file to see the required column
                headers and format
              </Typography>

              <Button
                variant="contained"
                size="large"
                color="primary"
                startIcon={<Download />}
                onClick={() =>
                  downLoadFile(
                    // "whatsapp_market_campaign/Campaign-Audience(in).csv"
                    "whatsapp_market_campaign/Campaign_Audience_in__2025_09_09_11_30_57__2___2__2025-09-17_17-54-30.xlsx"
                  )
                }
                sx={{ mt: 2 }}
              >
                Download Sample File (CSV/Excel)
              </Button>
            </Box>
          </Box>
        </Grid> */}

          <Grid item xs={12} sx={{ my: 2, ml: -1.5 }}>
            <Divider sx={{ rotate: "90deg", width: "50px" }} />
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Typography
                sx={{
                  minWidth: "30px",
                  height: "30px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  borderRadius: "50%",
                  backgroundColor: "primary.main",
                  color: "white",
                  fontWeight: "bold",
                }}
              >
                1
              </Typography>

              {type === "AUDIENCE" && (
                <Box>
                  <Typography variant="h3" fontWeight={600}>
                    Upload Your Data File
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                    Fill in your data using the same format and upload your
                    completed file
                  </Typography>

                  {formData.source_link.length > 0 ? (
                    <Box>
                      <SingleFileDisplay
                        value={formData.source_link[0]}
                        onDelete={() => {
                          setFormData((prev) => ({ ...prev, source_link: [] }));
                          setMappingKeys([]);
                          setIsMappingCompleted(false);
                        }}
                      />
                      {isMappingCompleted ? (
                        <Box
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "#f0fdf4",
                            borderRadius: 1,
                            border: "1px solid #bbf7d0",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="success.dark"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            ✓ Field mapping completed successfully
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            {mappingKeys.length} fields mapped
                          </Typography>
                        </Box>
                      ) : (
                        <Box
                          sx={{
                            mt: 2,
                            p: 2,
                            backgroundColor: "#fef3c7",
                            borderRadius: 1,
                            border: "1px solid #fbbf24",
                          }}
                        >
                          <Typography
                            variant="body2"
                            color="warning.dark"
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              gap: 1,
                            }}
                          >
                            ⚠️ Field mapping required
                          </Typography>
                          <Typography
                            variant="caption"
                            color="text.secondary"
                            sx={{ display: "block" }}
                          >
                            Please complete the field mapping before saving
                          </Typography>
                        </Box>
                      )}
                    </Box>
                  ) : (
                    <>
                      <ExcelFileUplaodButtonAsync
                        onUploadSuccess={handleAudienceFileUploadSuccess}
                      />
                      {error && !formData.source_link.length && (
                        <Typography color="error" variant="caption">
                          {error}
                        </Typography>
                      )}
                    </>
                  )}
                </Box>
              )}

              {type === "TEMPLATE" && (
                <Box>
                  <Typography variant="h3" fontWeight={600}>
                    Upload Your Data File Template
                  </Typography>
                  <Typography variant="body1" sx={{ mt: 2, mb: 2 }}>
                    Fill in your data using the same format and upload your
                    completed file
                  </Typography>
                  <ExcelFileUplaodButtonAsync
                    onUploadSuccess={
                      fileUploadSuccess ||
                      ((path: string) => {
                        console.log("path:", path);
                      })
                    }
                  />
                </Box>
              )}
            </Box>
          </Grid>

          <Grid item xs={12} sx={{ my: 2, ml: -1.5 }}>
            <Divider sx={{ rotate: "90deg", width: "50px" }} />
          </Grid>

          <Grid item xs={12}>
            <Box sx={{ display: "flex", gap: 2 }}>
              <Box
                sx={{
                  borderRadius: "50%",

                  color: "primary.main",
                  fontWeight: "bold",
                }}
              >
                <DescriptionIcon sx={{ fontSize: 30 }} />
              </Box>
              <Box>
                <Typography variant="h3" fontWeight={600} mb={2}>
                  Tips for best results:
                </Typography>
                <Typography variant="body1" component="ul" sx={{ pl: 2 }}>
                  <li>
                    Keep the column headers exactly as shown in the sample file
                  </li>
                  <li>Save your file as CSV or Excel (.xlsx) format</li>
                  <li>Ensure there are no empty rows between data entries</li>
                  <li>Remove any extra formatting or special characters</li>
                </Typography>
              </Box>
            </Box>
          </Grid>
        </Grid>
      </RightPanel>
      {openMappedAudience && (
        <MappedAudience
          open={openMappedAudience}
          uploadedHeaders={uploadedHeaders}
          onClose={() => setOpenMappedAudience(false)}
          previewListAction={handleMappingComplete}
          existingMappings={mappingKeys}
        />
      )}
    </>
  );
};
